import { ContentfulMessage } from '../PollieRater/types'

export interface ElectionNightFields {
    /** The fields casn either be one of the election day results or it can be the votes counted (number) */
    [property: string]: ElectionDayResultFields | number
}

export interface BaseContentfulQueryResponse<T> {
    sys: {
        type: 'Array'
    }
    total: number
    skip: number
    limit: number
    items: Array<T>
}

// Raw data from Contentful
export interface BaseElectionDayWidgetMessage
    extends Omit<ContentfulMessage, 'fields'> {
    fields: ElectionNightFields
}

export type BaseElectionDayQueryResponse = BaseContentfulQueryResponse<BaseElectionDayWidgetMessage>

export type ElectionDayResultFields =
    | 'coalition'
    | 'coalitionLikely'
    | 'labor'
    | 'laborLikely'
    | 'greens'
    | 'greensLikely'
    | 'undecided'
    | 'other'
    | 'otherLikely'

export type VotesCountedField = 'votesCounted'

export type ElectionDayFields = ElectionDayResultFields | VotesCountedField

// Used to typeguard ElectionDayResults
export const ELECTION_DAY_RESULTS = [
    'coalition',
    'coalitionLikely',
    'labor',
    'laborLikely',
    'greens',
    'greensLikely',
    'undecided',
    'other',
    'otherLikely',
]

export const isElectionDayField = (
    result: string,
): result is ElectionDayResultFields => ELECTION_DAY_RESULTS.includes(result)

export type ElectionDayData = {
    coalition: number
    coalitionLikely: number
    labor: number
    laborLikely: number
    greens: number
    greensLikely: number
    undecided: number
    other: number
    otherLikely: number
    votesCounted: number
    /** Unix timestamp */
    lastUpdated: number | undefined
}
